// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert--2I6QS"};